export const formatCurrency = (amount: number) => {
  let text = new Intl.NumberFormat("es-ES", {
    style: "currency",
    currency: "UYU",
  }).format(amount);
  return `$${text.replace("UYU", "")}`;
};
